var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"balance",class:{ invert: _vm.invert },on:{"click":_vm.swapCurrencies}},[_c('span',{staticClass:"left"},[_vm._v(_vm._s(_vm.prices[0]))]),_c('small',[_vm._v(" ⇄ ")]),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.prices[1]))])])
}
var staticRenderFns = []

export { render, staticRenderFns }